/* ============================================================
   Think4Earth custom scripts (see CUSTOM-CODE-REGISTER.md)
   Moved out of layout/theme.liquid 22 Jul 2026 so browsers cache
   this once instead of re-downloading it inside every page.
   Blocks: cart-drawer AJAX remove / main page tweaks /
   wholesale form styling / FAQ auto-close / AOV bundle enhancer
   ============================================================ */

/* ---- Block 0: fetch response normaliser (app-conflict guard) ----
   Fast Bundle (and other cart apps) monkey-patch window.fetch. One wrapper
   returns responses whose .json()/.text() don't return real Promises, which
   crashes the Section Store cart drawer ("t.json().catch is not a function")
   and blocks bundle add-to-cart. After all app scripts have loaded, wrap the
   final fetch chain once so json()/text() always return real Promises. */
(function () {
  function install() {
    var inner = window.fetch;
    if (!inner) return;
    var outer = function () {
      var p;
      try { p = inner.apply(window, arguments); } catch (e) { return Promise.reject(e); }
      return Promise.resolve(p).then(function (r) {
        if (r && typeof r.json === 'function') {
          var oj = r.json.bind(r);
          r.json = function () { try { return Promise.resolve(oj()); } catch (e) { return Promise.reject(e); } };
        }
        if (r && typeof r.text === 'function') {
          var ot = r.text.bind(r);
          r.text = function () { try { return Promise.resolve(ot()); } catch (e) { return Promise.reject(e); } };
        }
        return r;
      });
    };
    window.fetch = outer;
  }
  if (document.readyState === 'complete') {
    setTimeout(install, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(install, 300); });
  }
})();

/* ---- Block 2: cart drawer AJAX remove ---- */
(function() {
  document.addEventListener('click', function(e) {
    if (e.target.closest('#CartDrawer .cart__remove a')) e.preventDefault();
  }, true);

  function doRemove(originalHref, cartItemEl) {
    var params = new URLSearchParams(new URL(originalHref, window.location.origin).search);
    var id = params.get('id');
    if (!id) return;
    if (cartItemEl) cartItemEl.style.opacity = '0.3';
    fetch('/cart/change.js?id=' + encodeURIComponent(id) + '&quantity=0')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-link__bubble-num').forEach(function(el) {
          el.textContent = cart.item_count;
        });
        if (cartItemEl) cartItemEl.remove();
      });
  }

  function wireRemoveButtons() {
    document.querySelectorAll('#CartDrawer .cart__remove a:not([data-t4e-wired])').forEach(function(link) {
      link.setAttribute('data-t4e-wired', '1');
      var originalHref = link.href;
      link.href = 'javascript:void(0)';
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var cartItem = link.closest('.cart__item') ||
                       link.closest('[class*="cart-item"]') ||
                       link.parentElement.parentElement;
        doRemove(originalHref, cartItem);
      });
    });
  }

  var cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    new MutationObserver(wireRemoveButtons).observe(cartDrawer, { childList: true, subtree: true });
  }
  wireRemoveButtons();
})();

/* ---- Block 2b: strip ".00" from whole-dollar prices, site-wide ----
   Text-node based so it never breaks event listeners; observer-driven so it
   catches dynamically rendered content; and shadow-DOM-aware so it reaches
   the Section Store cart drawer (custom element with an open shadow root).
   $20.00 -> $20, but $20.50 stays $20.50. JS on purpose: Shopify's
   no-decimals money format ROUNDS non-whole prices. */
(function () {
  var TEST_RE = /\$\s?[\d,]+\.00(?!\d)/;
  var REPLACE_RE = /(\$\s?[\d,]+)\.00(?!\d)/g;
  var observedRoots = new WeakSet();
  var mo = new MutationObserver(run);
  function stripTree(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        if (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA' || p === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
        return TEST_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) { n.nodeValue = n.nodeValue.replace(REPLACE_RE, '$1'); });
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) {
        if (!observedRoots.has(el.shadowRoot)) {
          observedRoots.add(el.shadowRoot);
          mo.observe(el.shadowRoot, { childList: true, subtree: true, characterData: true });
        }
        stripTree(el.shadowRoot);
      }
    });
  }
  var t;
  function run() { clearTimeout(t); t = setTimeout(function () { if (document.body) stripTree(document.body); }, 150); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* ---- Block 3: main page tweaks ---- */
document.addEventListener('DOMContentLoaded', function() {

  // Stars above title
  document.querySelectorAll('.product-section').forEach(function(section) {
    var stars = section.querySelector('.shopify-app-block');
    var header = section.querySelector('.product-block--header');
    if (stars && header) header.insertBefore(stars, header.firstChild);
  });

  // Hide dispatch sales point when product is out of stock
  var dispatchPoint = Array.from(document.querySelectorAll('.product-block--sales-point')).find(function(el) {
    return el.innerText.includes('12pm') || el.innerText.includes('dispatch');
  });
  if (dispatchPoint) {
    var productPath = window.location.pathname.replace(/\?.*/, '');
    var match = productPath.match(/\/products\/[^\/]+/);
    if (match) {
      fetch(match[0] + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          if (!product.available) dispatchPoint.style.display = 'none';
        });
    }
  }

  var isProductPage = window.location.pathname.indexOf('/products/') !== -1;

  // Hide price on bread bag & baguette bag pages (price shown in bundle widget)
  var isBreadOrBaguette = (window.location.pathname.includes('bread-bag') || window.location.pathname.includes('baguette-bag')) && !window.location.pathname.includes('cotton') && !window.location.pathname.includes('beeswax');
  if (isBreadOrBaguette) {
    var priceBlock = document.querySelector('.product-block--price');
    if (priceBlock) priceBlock.style.display = 'none';
  }

  // Orange underline under "Bundle and Save" heading (product pages only)
  if (isProductPage) {
    var bundleUnderlineAdded = false;
    var addBundleUnderline = function() {
      if (bundleUnderlineAdded) return;
      var bundleTitle = document.querySelector('.bundle-title');
      if (bundleTitle) {
        bundleUnderlineAdded = true;
        bundleTitle.style.position = 'relative';
        bundleTitle.style.paddingBottom = '18px';
        var ul = document.createElement('div');
        ul.style.cssText = 'position:absolute;bottom:0;left:50%;transform:translateX(-50%);width:110px;height:4px;background:#F27B26;border-radius:2px;';
        bundleTitle.appendChild(ul);
      }
    };
    addBundleUnderline();
    var bundleObserver = new MutationObserver(function() {
      if (!bundleUnderlineAdded) addBundleUnderline();
      else bundleObserver.disconnect();
    });
    bundleObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Feature icons — bread bag & baguette bag pages
  if (isBreadOrBaguette) {
    var featureItems = [
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>', text: 'Keeps Bread Fresh Longer' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="3"/><circle cx="12" cy="13" r="4.5"/><path d="M5 6h3"/></svg>', text: 'Machine Washable' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><polyline points="9 5 12 2 15 5"/><polyline points="9 19 12 22 15 19"/><polyline points="5 9 2 12 5 15"/><polyline points="19 9 22 12 19 15"/></svg>', text: 'Bench, Fridge & Freezer Safe' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"/></svg>', text: 'Stops Freezer Burn' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 10 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"/></svg>', text: 'Breathable — Prevents Mould Growth*' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>', text: 'Made from Recycled Bottles' }
    ];
    var featHtml = '<div class="t4e-features">' + featureItems.map(function(f) {
      return '<div class="t4e-feature">' + f.icon + '<span>' + f.text + '</span></div>';
    }).join('') + '</div>';
    var descBlock = null;
    document.querySelectorAll('.product-single__meta .product-block').forEach(function(block) {
      if (block.innerText && (block.innerText.includes('150,000') || block.innerText.includes('Keep bread') || block.innerText.includes('Thoughtfully'))) {
        descBlock = block;
      }
    });
    if (descBlock) {
      descBlock.insertAdjacentHTML('afterend', featHtml);
    } else {
      var priceEl = document.querySelector('.product__price');
      if (priceEl) priceEl.insertAdjacentHTML('afterend', featHtml);
    }
  }

  // Mobile nav drawer — announcement bar fix, ✕ icon, scroll lock, Shop sub-panel
  (function() {
    var hamburger = document.querySelector('.js-drawer-open-nav');
    var navDrawer  = document.getElementById('NavDrawer') || document.querySelector('.drawer--right');
    var header    = document.querySelector('.site-header');
    if (!hamburger || !navDrawer) return;

    var xSpan = document.createElement('span');
    xSpan.style.cssText = 'display:none;font-size:22px;font-weight:300;color:#333;line-height:1;pointer-events:none;';
    hamburger.appendChild(xSpan);
    xSpan.textContent = '✕';
    var hamIcon = hamburger.querySelector('.icon-hamburger, svg');

    function preventTouch(e) {
      if (!e.target.closest('.drawer--right') && !e.target.closest('#t4e-sub-panel')) e.preventDefault();
    }

    var subPanel = null;
    var subPanelTop = 0;

    function buildSubPanel() {
      if (subPanel) return;
      var shopLink = null;
      navDrawer.querySelectorAll('.mobile-nav__link--top-level').forEach(function(el) {
        if (el.textContent.trim().toLowerCase() === 'shop') shopLink = el;
      });
      var parentItem = shopLink ? shopLink.closest('.mobile-nav__item--has-children, li') : null;
      var subList = parentItem ? parentItem.querySelector('ul, .mobile-nav__dropdown') : null;

      subPanel = document.createElement('div');
      subPanel.id = 't4e-sub-panel';
      subPanel.style.cssText = 'position:fixed;top:0;right:0;bottom:0;width:100%;max-width:320px;background:#fff;z-index:1000001;overflow-y:auto;-webkit-overflow-scrolling:touch;transition:transform 0.3s cubic-bezier(0.165,0.84,0.44,1);transform:translateX(110%);';

      var backBtn = document.createElement('button');
      backBtn.style.cssText = 'display:flex;align-items:center;gap:8px;width:100%;padding:16px 20px;border:none;background:none;font-size:15px;font-weight:600;color:#333;cursor:pointer;border-bottom:1px solid #eee;';
      backBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg> Shop';
      backBtn.addEventListener('click', closeSubPanel);
      subPanel.appendChild(backBtn);

      if (subList) {
        subList.querySelectorAll('a').forEach(function(a) {
          var item = document.createElement('a');
          item.href = a.href;
          item.textContent = a.textContent.trim();
          item.style.cssText = 'display:block;padding:14px 20px;font-size:15px;color:#333;text-decoration:none;border-bottom:1px solid #f0f0f0;';
          subPanel.appendChild(item);
        });
      }
      document.body.appendChild(subPanel);
    }

    function openSubPanel() {
      buildSubPanel();
      subPanel.style.top = subPanelTop + 'px';
      subPanel.style.transform = 'translateX(0)';
    }
    function closeSubPanel() {
      if (subPanel) subPanel.style.transform = 'translateX(110%)';
    }

    function wireShopTap() {
      navDrawer.querySelectorAll('.mobile-nav__item--has-children').forEach(function(item) {
        var topLink = item.querySelector('.mobile-nav__link--top-level');
        if (!topLink) return;
        var text = topLink.textContent.trim().toLowerCase();
        if (text !== 'shop' && !text.startsWith('shop')) return;
        var expander = item.querySelector('.mobile-nav__toggle, .mobile-nav__arrow, button');
        var trigger = expander || topLink;
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openSubPanel();
        }, true);
      });
    }

    var overlaySelectors = '.site-overlay, .drawer-overlay, .page-overlay, #DrawerOverlay, .js-overlay, .drawer__overlay';
    var overlayObs = null;
    var overlayBottom = 0;
    function fixOverlay() {
      document.querySelectorAll(overlaySelectors).forEach(function(el) {
        el.style.setProperty('top', overlayBottom + 'px', 'important');
      });
    }
    function watchForOverlay() {
      if (overlayObs) return;
      overlayObs = new MutationObserver(fixOverlay);
      overlayObs.observe(document.body, { childList: true, subtree: false });
    }
    function unwatchOverlay() {
      if (overlayObs) { overlayObs.disconnect(); overlayObs = null; }
      document.querySelectorAll(overlaySelectors).forEach(function(el) { el.style.removeProperty('top'); });
    }

    function onOpen() {
      var annoBar = document.querySelector('.announcement-bar, .announcement-bar-section, [class*="announcement"]');
      var annoBottom = 0;
      if (annoBar) annoBottom = Math.max(0, annoBar.getBoundingClientRect().bottom);
      if (header) {
        var headerHeight = header.getBoundingClientRect().height;
        var drawerTop = annoBottom + headerHeight;
        header.style.setProperty('position', 'fixed', 'important');
        header.style.setProperty('top', annoBottom + 'px', 'important');
        header.style.setProperty('left', '0', 'important');
        header.style.setProperty('right', '0', 'important');
        header.style.setProperty('z-index', '999999', 'important');
        header.style.setProperty('background', '#fff', 'important');
        navDrawer.style.setProperty('top', drawerTop + 'px', 'important');
        overlayBottom = drawerTop;
        subPanelTop = drawerTop;
      }
      fixOverlay();
      watchForOverlay();
      if (hamIcon) hamIcon.style.display = 'none';
      xSpan.style.display = 'block';
      document.body.classList.add('t4e-nav-open');
      document.addEventListener('touchmove', preventTouch, { passive: false });
      wireShopTap();
    }

    function onClose() {
      if (header) {
        header.style.removeProperty('position');
        header.style.removeProperty('top');
        header.style.removeProperty('left');
        header.style.removeProperty('right');
        header.style.removeProperty('z-index');
        header.style.removeProperty('background');
      }
      navDrawer.style.removeProperty('top');
      unwatchOverlay();
      if (hamIcon) hamIcon.style.display = '';
      xSpan.style.display = 'none';
      document.body.classList.remove('t4e-nav-open');
      document.removeEventListener('touchmove', preventTouch);
      closeSubPanel();
    }

    new MutationObserver(function() {
      navDrawer.classList.contains('drawer--is-open') ? onOpen() : onClose();
    }).observe(navDrawer, { attributes: true, attributeFilter: ['class'] });

    hamburger.addEventListener('click', function(e) {
      if (navDrawer.classList.contains('drawer--is-open')) {
        e.stopImmediatePropagation();
        var closeBtn = document.querySelector('.drawer__close');
        if (closeBtn) closeBtn.click();
      }
    }, true);
  })();

  // Free shipping progress bar on cart page — updates live when quantities change.
  // Initial bar is server-rendered by snippets/t4e-free-shipping-bar.liquid;
  // this script only refreshes it after cart changes.
  if (window.location.pathname === '/cart') {
    (function() {
      var threshold = 14000; // $140 in cents — keep in sync with snippets/t4e-free-shipping-bar.liquid
      var debounceTimer;
      var busy = false;

      function buildBarHTML(totalCents) {
        var remaining = Math.max(0, threshold - totalCents);
        var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
        var msg = remaining > 0
          ? 'You are <strong>$' + (remaining / 100).toFixed(2) + '</strong> away from free shipping.'
          : 'You\'ve unlocked <strong>free shipping!</strong> 🎉';
        return '<p style="font-size:13px;text-align:center;margin:0 0 8px;color:#333;">' + msg + '</p>' +
          '<div style="background:#e0e0e0;border-radius:4px;height:6px;overflow:hidden;">' +
            '<div style="background:#F27B26;height:100%;width:' + pct + '%;border-radius:4px;transition:width 0.4s;"></div>' +
          '</div>';
      }

      function insertOrUpdateBar(totalCents) {
        var existing = document.getElementById('t4e-cart-shipping-bar');
        if (existing) {
          busy = true;
          existing.innerHTML = buildBarHTML(totalCents);
          setTimeout(function() { busy = false; }, 150);
          return true;
        }
        var main = document.getElementById('MainContent') || document.querySelector('main');
        var btn = main && (
          main.querySelector('input[name="checkout"]') ||
          main.querySelector('button[name="checkout"]') ||
          main.querySelector('.cart__checkout') ||
          main.querySelector('[name="checkout"]')
        );
        if (!btn) return false;
        var bar = document.createElement('div');
        bar.id = 't4e-cart-shipping-bar';
        bar.style.cssText = 'padding:10px 0 14px;';
        bar.innerHTML = buildBarHTML(totalCents);
        btn.parentNode.insertBefore(bar, btn);
        return true;
      }

      function refresh() {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          if (cart.item_count) insertOrUpdateBar(cart.total_price);
        });
      }

      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        if (!cart.item_count) return;
        var attempts = 0;
        var iv = setInterval(function() {
          if (insertOrUpdateBar(cart.total_price) || ++attempts >= 20) clearInterval(iv);
        }, 200);
      });

      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) {
        new MutationObserver(function(mutations) {
          if (busy) return;
          var bar = document.getElementById('t4e-cart-shipping-bar');
          var selfChange = bar && mutations.every(function(m) {
            return bar === m.target || bar.contains(m.target);
          });
          if (!selfChange) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(refresh, 500);
          }
        }).observe(main, { childList: true, characterData: true, subtree: true });
      }
    })();
  }

  // Orange Add buttons in bundle widget (product pages only, debounced)
  if (isProductPage) {
    var styleBundleTimer;
    var styleBundleAddBtns = function() {
      document.querySelectorAll('[class*="bundle"] button, [class*="Bundle"] button').forEach(function(btn) {
        var txt = btn.textContent.trim().toLowerCase();
        if (txt === 'add' || txt === 'added') {
          btn.style.setProperty('background', '#F27B26', 'important');
          btn.style.setProperty('color', '#fff', 'important');
          btn.style.setProperty('border-color', '#F27B26', 'important');
          btn.style.setProperty('border-radius', '4px', 'important');
        }
      });
    };
    styleBundleAddBtns();
    new MutationObserver(function() {
      clearTimeout(styleBundleTimer);
      styleBundleTimer = setTimeout(styleBundleAddBtns, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

});

/* ---- Block 4: wholesale form styling ---- */
(function() {
  if (!window.location.pathname.includes('wholesale-registration')) return;
  function styleWholesaleForm() {
    var embed = document.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return false;
    if (embed.shadowRoot.querySelector('#t4e-wholesale-style')) return true;
    var style = document.createElement('style');
    style.id = 't4e-wholesale-style';
    style.textContent =
      'h1,h2,h3{text-transform:uppercase!important}' +
      'h1:first-of-type,h2:first-of-type,h3:first-of-type{' +
        'position:relative!important;' +
        'padding-bottom:22px!important;' +
        'margin-bottom:24px!important' +
      '}' +
      'h1:first-of-type::after,h2:first-of-type::after,h3:first-of-type::after{' +
        'content:"";display:block;position:absolute;bottom:0;left:50%;' +
        'transform:translateX(-50%);width:110px;height:4px;' +
        'background:#F27B26;border-radius:2px' +
      '}' +
      'button[type="submit"]{' +
        'background:#F27B26!important;' +
        'border-color:#F27B26!important;' +
        'color:#fff!important' +
      '}';
    embed.shadowRoot.appendChild(style);
    return true;
  }
  if (!styleWholesaleForm()) {
    var obs = new MutationObserver(function() {
      if (styleWholesaleForm()) obs.disconnect();
    });
    obs.observe(document.body, {childList: true, subtree: true});
  }
})();

/* ---- Block 5: FAQ auto-close ---- */
(function () {
  function contentOf(t) {
    var id = t.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }
  function isOpen(t) {
    if (t.getAttribute('aria-expanded') === 'true') return true;
    if (t.classList.contains('is-open')) return true;
    var c = contentOf(t);
    return !!(c && c.offsetHeight > 5);
  }
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var trigger = e.target.closest('.faq-item .collapsible-trigger');
    if (!trigger) return;
    setTimeout(function () {
      if (!isOpen(trigger)) return;
      document.querySelectorAll('.faq-item .collapsible-trigger').forEach(function (other) {
        if (other !== trigger && isOpen(other)) other.click();
      });
    }, 60);
  });
})();

/* ---- Block 6: AOV.ai bundle widget enhancer ---- */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  var subs = {
    1: 'Try one now',
    2: 'One on the bench, one in the freezer',
    3: 'One on the bench, one in the freezer, one to gift'
  };
  // T4E: pre-select the 2-pack once per page load, unless the shopper
  // has already interacted with the widget. Since 24 Sep 2026 the Liquid in
  // snippets/Qty-table.liquid renders the 2-pack as active, so this is only
  // a fallback (activeIdx > 0 on load → no click, no visible jump).
  var preselected = false;
  var preselectTries = 0;
  var userTouched = false;
  document.addEventListener('pointerdown', function (ev) {
    var pth = ev.composedPath ? ev.composedPath() : [];
    for (var k = 0; k < pth.length; k++) {
      var n = pth[k];
      if (n && n.classList && (n.classList.contains('bundle-widget') || n.classList.contains('bundle-option'))) { userTouched = true; break; }
    }
  }, true);
  function money(el){ return el ? (parseFloat((el.textContent||'').replace(/[^0-9.]/g,''))||0) : 0; }
  function enhance() {
    var opts = document.querySelectorAll('.bundle-option');
    if (!opts.length) return;
    if (!preselected && !userTouched && opts.length > 1) {
      var activeIdx = -1;
      for (var ai = 0; ai < opts.length; ai++) {
        if (opts[ai].className.indexOf('active') > -1) { activeIdx = ai; break; }
      }
      if (activeIdx > 0) {
        preselected = true;
      } else {
        opts[1].click();
        if (opts[1].className.indexOf('active') > -1) {
          preselected = true;
        } else {
          preselectTries++;
          if (preselectTries > 10) preselected = true;
        }
      }
    }
    opts.forEach(function (opt) {
      var label = opt.querySelector('.bundle-pack-label');
      if (!label) return;
      // Normalise "2-PACK" / "3-PACK" to "2 PACK" / "3 PACK" (match "1 PACK")
      if (/\d\s*-\s*PACK/i.test(label.textContent)) {
        label.textContent = label.textContent.replace(/(\d)\s*-\s*(PACK)/gi, '$1 $2');
      }
      var priceEl = opt.querySelector('.bundle-price .money');
      var compareEl = opt.querySelector('.bundle-compare-price .money');
      var packCount = parseInt((label.textContent.match(/\d+/) || ['1'])[0], 10);

      if (!label.closest('.bundle-label-col')) {
        var col = document.createElement('div'); col.className = 'bundle-label-col';
        var top = document.createElement('div'); top.className = 'bundle-label-top';
        label.parentNode.insertBefore(col, label);
        top.appendChild(label);
        col.appendChild(top);
        if (packCount > 1 && priceEl) {
          var price = money(priceEl);
          if (price) {
            var each = document.createElement('span');
            each.className = 'bundle-each';
            each.textContent = '$' + (price / packCount).toFixed(2).replace(/\.00$/, '') + ' each';
            top.appendChild(each);
          }
        }
        if (subs[packCount]) {
          var sub = document.createElement('div');
          sub.className = 'bundle-subtitle';
          sub.textContent = subs[packCount];
          col.appendChild(sub);
        }
      }

      var nativeBadge = opt.querySelector('.bundle-popular-badge:not(.bundle-best-badge)');
      if (nativeBadge && !/SAVE/i.test(nativeBadge.textContent)) {
        var s = Math.round(money(compareEl) - money(priceEl));
        if (s > 0) nativeBadge.textContent = nativeBadge.textContent.trim() + ' · SAVE $' + s;
      }
    });

    var last = opts[opts.length - 1];
    var lastHeader = last && last.querySelector('.bundle-option-header');
    if (lastHeader && !lastHeader.querySelector('.bundle-popular-badge')) {
      var save = Math.round(money(last.querySelector('.bundle-compare-price .money')) - money(last.querySelector('.bundle-price .money')));
      var b = document.createElement('span');
      b.className = 'bundle-popular-badge bundle-best-badge';
      b.textContent = save > 0 ? ('Best value · save $' + save) : 'Best value';
      lastHeader.appendChild(b);
    }

    document.querySelectorAll('.bundle-color-label').forEach(function (p) {
      p.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /Your Colou?rs?:/i.test(n.textContent)) {
          n.textContent = n.textContent.replace(/Your Colou?rs?:/i, 'Colour:');
        }
      });
    });
    document.querySelectorAll('.bundle-color-label [class*="selected-colors-text"]').forEach(function (el) {
      if (/Bags?\s*-/i.test(el.textContent)) {
        el.textContent = el.textContent.replace(/Reusable\s+\w+\s+Bag\s*-\s*/gi, '').replace(/Beeswax-Lined\s+(?:Organic\s+)?Cotton\s+Bread\s+Bags?\s*-\s*/gi, '').replace(/,\s*$/, '').trim();
      }
    });
  }
  var t;
  function run() { clearTimeout(t); t = setTimeout(enhance, 80); }
  document.addEventListener('DOMContentLoaded', run);
  run();
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();

/* ---- Block 7: cart drawer upsell — send bundles to their product page ----
   The Section Store cart's "You may also like" +Add can't quick-add Fast
   Bundle products (they need component selection on their page), failing
   with "Please select all variants correctly". Intercept +Add clicks in
   the cart block (document-level capture sees through the open shadow
   root via composedPath); if the clicked product is a Bundle (type
   "Bundle" / tag "bundle"), navigate to its product page instead;
   otherwise re-dispatch the click so the normal quick-add proceeds. */
(function () {
  var passthrough = false;
  document.addEventListener('click', function (e) {
    if (passthrough) return;
    var path = e.composedPath ? e.composedPath() : [];
    var inCart = path.some(function (el) { return el && el.tagName === 'SECTION-STORE--CART-BLOCK'; });
    if (!inCart) return;
    var btn = null;
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.tagName === 'SECTION-STORE--CART-BLOCK') break;
      if (el && el.tagName === 'BUTTON' && /^\+?\s*add$/i.test((el.textContent || '').trim())) { btn = el; break; }
    }
    if (!btn) return;
    var title = null;
    for (var j = path.indexOf(btn) + 1; j < path.length; j++) {
      var anc = path[j];
      if (!anc || !anc.textContent || anc.tagName === 'SECTION-STORE--CART-BLOCK') break;
      var txt = anc.textContent.replace(/\s+/g, ' ').trim();
      if (txt.length > 5 && txt.length < 300 && txt.indexOf('$') > -1) {
        title = txt.split('$')[0].replace(/\+?\s*Add\s*$/i, '').trim();
        break;
      }
    }
    if (!title) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=3')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var prod = s && s.resources && s.resources.results && s.resources.results.products && s.resources.results.products[0];
        if (!prod) throw new Error('no match');
        return fetch('/products/' + prod.handle + '.js').then(function (r) { return r.json(); });
      })
      .then(function (full) {
        if (full && (String(full.type).toLowerCase() === 'bundle' || (full.tags || []).indexOf('bundle') > -1)) {
          window.location.href = '/products/' + full.handle;
        } else {
          passthrough = true;
          btn.click();
          passthrough = false;
        }
      })
      .catch(function () {
        passthrough = true;
        btn.click();
        passthrough = false;
      });
  }, true);
})();

/* ---- Block 8: reward bar inside the Section Store drawer (v4 — milestone labels show the amounts: "Free gift · $80", "Free shipping · $140") ----
   Two milestones on one track, measured on cart.total_price from /cart.js
   (AFTER discounts, cache bypassed) so it agrees exactly with both real
   rewards: $80 free gift (auto-added by Block 10) and $140 free shipping
   (Shopify rate). Confetti cannon fires from a milestone the moment it
   unlocks (upward crossings only — no confetti on plain page loads).
   Amounts formatted without trailing ".00" so Block 2b never rewrites
   them. Reacts to drawer re-renders via MutationObserver with a slow
   interval as fallback; bar starts hidden until the cart state is known. */
(function () {
  var GIFT_AT = 8000;  // $80 in cents — keep in sync with Block 10
  var SHIP_AT = 14000; // $140 in cents — keep in sync with the Shopify shipping rate
  var GIFT_PCT = (GIFT_AT / SHIP_AT * 100).toFixed(2) + '%';
  var TRUCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var GIFTSVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var applying = false;
  var prevTotal = null;
  var observedBodies = new WeakSet();
  function fmt(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function host() {
    var ss = document.querySelector('section-store--cart-block');
    return ss && ss.shadowRoot ? ss.shadowRoot : null;
  }
  function ensureBar(root) {
    var bar = root.getElementById('t4e-drawer-ship-bar');
    if (bar) return bar;
    var body = root.querySelector('.cart-body');
    if (!body) return null;
    bar = document.createElement('div');
    bar.id = 't4e-drawer-ship-bar';
    bar.style.cssText = 'padding:14px 16px 6px;display:none;position:relative;';
    bar.innerHTML =
      '<div data-msg style="text-align:center;font-size:14px;color:#1f2a44;margin-bottom:12px;"></div>' +
      '<div style="position:relative;margin-right:14px;">' +
        '<div style="height:6px;background:#e6e6e6;border-radius:4px;overflow:hidden;">' +
          '<div data-fill style="height:100%;width:0%;background:#F27B26;border-radius:4px;transition:width .4s;"></div>' +
        '</div>' +
        '<div data-gift-badge style="position:absolute;left:' + GIFT_PCT + ';top:50%;transform:translate(-50%,-50%);width:26px;height:26px;border-radius:50%;background:#c7c7c7;display:flex;align-items:center;justify-content:center;transition:background .3s;">' + GIFTSVG + '</div>' +
        '<div data-badge style="position:absolute;right:-13px;top:50%;transform:translateY(-50%);width:26px;height:26px;border-radius:50%;background:#c7c7c7;display:flex;align-items:center;justify-content:center;transition:background .3s;">' + TRUCK + '</div>' +
      '</div>' +
      '<div style="position:relative;height:15px;margin-top:10px;padding-bottom:8px;margin-right:14px;">' +
        '<div data-gift-label style="position:absolute;left:' + GIFT_PCT + ';transform:translateX(-50%);font-size:11px;color:#1f2a44;white-space:nowrap;">Free gift · ' + fmt(GIFT_AT) + '</div>' +
        '<div data-label style="position:absolute;right:-14px;font-size:11px;color:#1f2a44;white-space:nowrap;">Free shipping · ' + fmt(SHIP_AT) + '</div>' +
      '</div>';
    body.insertBefore(bar, body.firstChild);
    return bar;
  }
  function confetti(bar, xFrac) {
    var cv = document.createElement('canvas');
    cv.width = 600; cv.height = 340;
    cv.style.cssText = 'position:absolute;left:0;bottom:-6px;width:100%;height:auto;pointer-events:none;z-index:9;';
    bar.appendChild(cv);
    var ctx = cv.getContext('2d');
    var W = cv.width, H = cv.height;
    var COLS = ['#F27B26', '#202F42', '#FFD166', '#6BBF59', '#E96479'];
    var parts = [];
    for (var i = 0; i < 80; i++) {
      var a = -Math.PI / 2 + (Math.random() - 0.5) * 1.3;
      var v = 5 + Math.random() * 8;
      parts.push({ x: W * xFrac, y: H * 0.8, vx: Math.cos(a) * v, vy: Math.sin(a) * v, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.35, w: 5 + Math.random() * 5, h: 3 + Math.random() * 3, c: COLS[i % COLS.length], life: 60 + Math.random() * 35 });
    }
    function tick() {
      ctx.clearRect(0, 0, W, H);
      var alive = false;
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        if (p.life <= 0) continue;
        alive = true;
        p.life--; p.x += p.vx; p.y += p.vy; p.vy += 0.22; p.vx *= 0.99; p.rot += p.vr;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, Math.min(1, p.life / 25));
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      if (alive) { requestAnimationFrame(tick); } else if (cv.parentNode) { cv.parentNode.removeChild(cv); }
    }
    requestAnimationFrame(tick);
  }
  function watch(root) {
    var body = root.querySelector('.cart-body');
    if (body && !observedBodies.has(body)) {
      observedBodies.add(body);
      new MutationObserver(function () { if (!applying) schedule(); }).observe(body, { childList: true, subtree: true });
    }
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 250); }
  function refresh() {
    var root = host();
    if (!root) return;
    watch(root);
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var root2 = host();
      if (!root2) return;
      var bar = ensureBar(root2);
      if (!bar) return;
      applying = true;
      if (!cart.item_count) {
        if (bar.style.display !== 'none') bar.style.display = 'none';
        prevTotal = 0;
      } else {
        if (bar.style.display !== 'block') bar.style.display = 'block';
        var total = cart.total_price;
        var pct = Math.min(100, Math.round(total / SHIP_AT * 100));
        var msg;
        if (total < GIFT_AT) {
          msg = 'Add <b>' + fmt(GIFT_AT - total) + '</b> to unlock a <b>Free gift</b>.';
        } else if (total < SHIP_AT) {
          msg = 'Free gift unlocked! Add <b>' + fmt(SHIP_AT - total) + '</b> to unlock <b>Free shipping</b>.';
        } else {
          msg = 'All rewards unlocked!';
        }
        var msgEl = bar.querySelector('[data-msg]');
        if (msgEl.innerHTML !== msg) msgEl.innerHTML = msg;
        var fillEl = bar.querySelector('[data-fill]');
        var w = pct + '%';
        if (fillEl.style.width !== w) fillEl.style.width = w;
        var gb = bar.querySelector('[data-gift-badge]');
        if (gb) gb.style.background = total >= GIFT_AT ? '#F27B26' : '#c7c7c7';
        var sb = bar.querySelector('[data-badge]');
        if (sb) sb.style.background = total >= SHIP_AT ? '#F27B26' : '#c7c7c7';
        var gl = bar.querySelector('[data-gift-label]');
        if (gl) gl.style.color = total >= GIFT_AT ? '#F27B26' : '#1f2a44';
        var sl = bar.querySelector('[data-label]');
        if (sl) sl.style.color = total >= SHIP_AT ? '#F27B26' : '#1f2a44';
        if (prevTotal !== null) {
          if (prevTotal < GIFT_AT && total >= GIFT_AT) confetti(bar, GIFT_AT / SHIP_AT);
          if (prevTotal < SHIP_AT && total >= SHIP_AT) confetti(bar, 0.97);
        }
        prevTotal = total;
      }
      setTimeout(function () { applying = false; }, 100);
    }).catch(function () { applying = false; });
  }
  setInterval(function () { if (host()) refresh(); }, 4000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 1500); });
  } else {
    setTimeout(refresh, 1500);
  }
})();

/* ---- Block 9: pre-order UX (v3, 6 Oct 2026 — beeswax bags, ship Wed 4 Nov) ----
   Driven by the product tag `pre-order`. snippets/t4e-site-overrides.liquid
   emits window.T4E_PREORDER = { ship, page, titles } on product pages
   (page = this product is tagged; titles = tagged products among this
   page's Qty-table colour list, itself included). The ship DATE lives in
   that snippet — not here.
   - In-stock pages: pre-order colours are removed from the Qty-table
     swatches, so an in-stock pack can never contain one (Dominic: pre-orders
     are placed on their own page, as their own order).
   - Pre-order pages: a required tick box sits above the Qty-table button;
     the button reads PRE-ORDER; pressing it unticked highlights the box and
     shows "Please tick the box above" instead of adding (capture-phase
     listener runs before the Qty-table's own handler); the "In Stock" sales
     point becomes "Pre-order — ships …"; every pre-order variant added gets
     the line property "Pre-order: Ships …" (shows in the drawer, checkout,
     order and packing slip) via a wrapper on fetch('/cart/add.js').
   - Block 13's sticky bar presses the same button, so it is gated too.
   v1/v2 (Sep 2026) only relabelled the button. Remove this block, Block 14,
   the snippet's script and the product tags when stock lands. */
(function () {
  var P = window.T4E_PREORDER;
  if (!P || !P.titles || !P.titles.length) return;
  var ship = P.ship || '';
  var isPre = {};
  P.titles.forEach(function (t) { isPre[t] = true; });

  function preVariantIds() {
    var ids = {}, d = window.bundleProductData || {};
    Object.keys(d).forEach(function (t) { if (isPre[t] && d[t] && d[t].variantId) ids[String(d[t].variantId)] = true; });
    return ids;
  }

  // line property on every pre-order add from this page
  (function () {
    var of = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
          var ids = preVariantIds();
          if (init.body instanceof FormData) {
            var id = String(init.body.get('id') || '');
            if (ids[id] && !init.body.has('properties[Pre-order]')) init.body.append('properties[Pre-order]', 'Ships ' + ship);
          } else if (typeof init.body === 'string' && init.body.charAt(0) === '{') {
            var j = JSON.parse(init.body), changed = false;
            var list = j.items || [j];
            list.forEach(function (it) {
              if (it && ids[String(it.id)]) { it.properties = it.properties || {}; if (!it.properties['Pre-order']) { it.properties['Pre-order'] = 'Ships ' + ship; changed = true; } }
            });
            if (changed) init.body = JSON.stringify(j);
          }
        }
      } catch (e) {}
      return of.apply(this, arguments);
    };
  })();

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  // in-stock page: drop pre-order colours from the pack swatches
  if (!P.page) {
    ready(function () {
      document.querySelectorAll('.bundle-color-swatch').forEach(function (sw) {
        if (isPre[sw.getAttribute('data-title')]) sw.parentNode.removeChild(sw);
      });
    });
    return;
  }

  // pre-order page
  var st = document.createElement('style');
  st.textContent =
    '.t4e-preorder-ack{display:flex;gap:10px;align-items:flex-start;margin-top:14px;padding:12px;border:1.5px solid #f37b26;border-radius:8px;background:#fff7f0;font-size:14px;line-height:1.45;color:#1f2a44;cursor:pointer;text-align:left;text-transform:none;letter-spacing:0;font-weight:400;font-family:inherit;}' +
    '.t4e-preorder-ack span{text-transform:none;letter-spacing:0;font-weight:400;}' +
    '.t4e-preorder-ack strong{font-weight:700;}' +
    '.t4e-preorder-ack input{width:20px;height:20px;margin:1px 0 0;flex:0 0 auto;accent-color:#f37b26;cursor:pointer;}' +
    '.t4e-preorder-ack.is-missing{border-color:#c0392b;background:#fdf1ef;animation:t4eShake .35s;}' +
    '.t4e-preorder-msg{margin:8px 0 0;font-size:13px;font-weight:700;color:#c0392b;text-align:center;text-transform:none;letter-spacing:0;}' +
    '@keyframes t4eShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}';
  document.head.appendChild(st);

  var ack = null, box = null, msg = null;
  function btnEl() { return document.getElementById('BundleATCBtn') || document.querySelector('.bundle-atc-btn'); }
  function selectedTitles() {
    var act = document.querySelector('.bundle-option.active');
    if (!act) return [];
    return [].map.call(act.querySelectorAll('.bundle-color-swatch.selected'), function (sw) { return sw.getAttribute('data-title'); });
  }
  function needsAck() { return selectedTitles().some(function (t) { return isPre[t]; }); }
  function build() {
    var btn = btnEl();
    if (!btn || ack) return;
    ack = document.createElement('label');
    ack.className = 't4e-preorder-ack';
    ack.innerHTML = '<input type="checkbox"><span>I understand this is a <strong>pre-order that ships on ' + ship + '</strong>. Anything else in the same order ships with it — if you need the rest sooner, please place two separate orders.</span>';
    msg = document.createElement('p');
    msg.className = 't4e-preorder-msg';
    msg.textContent = 'Please tick the box above to pre-order.';
    msg.hidden = true;
    btn.parentNode.insertBefore(ack, btn);
    btn.parentNode.insertBefore(msg, btn);
    box = ack.querySelector('input');
    box.addEventListener('change', function () { if (box.checked) { ack.classList.remove('is-missing'); msg.hidden = true; } });
  }
  function relabel() {
    var btn = btnEl();
    if (!btn || btn.classList.contains('btn--loading') || btn.disabled) return;
    var want = needsAck() ? 'PRE-ORDER' : 'ADD TO CART';
    if (btn.textContent.trim().toUpperCase() !== want) btn.textContent = want;
    if (ack) ack.style.display = needsAck() ? '' : 'none';
  }
  function salesPoint() {
    var nodes = document.querySelectorAll('.product-single__meta .sales-point span, .product-single__meta .sales-point');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.children.length === 0 && /^in stock\s*[—–-]\s*order before/i.test(n.textContent.trim())) { n.textContent = 'Pre-order — ships ' + ship; break; }
    }
  }
  // gate: capture phase, so it runs before the Qty-table's own click handler
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#BundleATCBtn, .bundle-atc-btn') : null;
    if (!btn || !box || !needsAck() || box.checked) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    ack.classList.remove('is-missing'); void ack.offsetWidth; ack.classList.add('is-missing');
    msg.hidden = false;
    try { ack.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
    try { box.focus({ preventScroll: true }); } catch (err2) {}
  }, true);
  function tick() { build(); relabel(); }
  ready(function () {
    tick(); salesPoint();
    document.addEventListener('click', function () { setTimeout(tick, 50); }, true);
    setInterval(tick, 1500);
  });
})();

/* ---- Block 10: auto-add the FREE GIFT product over $80 (v6) ----
   Uses the hidden $0 product "Free Gift" (product 9003908497579, variant
   47844868063403, type "free-gift" — NEVER type "add-on": SellUp blocks
   direct cart-adds of that type). NO discount involved — a BXGY/product
   discount can't combine with the multi-buy "Discount for 2/3" pricing, so
   the gift is simply a $0 product this block adds/removes by threshold.
   Rules (v4 — polices EVERY line of the gift variant, however it got there;
   it's a $0 product so there is no "shopper's own bag" to protect):
   - Eligible total (excludes the gift itself, add-ons, wholesale) ≥ $80
     → exactly ONE gift line at quantity 1 (extra lines / quantities are
     collapsed). Under $80 → every gift line removed.
   - Our own removal clears the "added" memory so the gift returns when the
     cart climbs back over; only a SHOPPER deleting it while still eligible
     counts as "no thanks" for the rest of the session.
   - The +/− quantity stepper is hidden on the gift line inside the Section
     Store drawer (shadow DOM: .cart-line-item > .cart-line-quantity) so
     shoppers can't bump it.
   - Session memory via try/catch helpers with in-memory fallback (iOS
     Safari storage restrictions). Gives up after 3 failed adds per load.
   - v5: stands down for 20s while Block 11 (checkout popup) is adding
     items + the gift itself (window.__t4eGiftHold) — both adding the same
     $0 variant at once merged into ONE line at quantity 2 (order #3164).
   - v6 (6 Oct 2026): keeps the Section Store drawer in step. The drawer
     deletes by LINE NUMBER from its own last render, and it never saw our
     plain-fetch changes (Fast Bundle's fetch patch bypasses the drawer's
     observer). So after we added the gift (always line 1) the drawer's
     list was one line out: the shopper's bin click on the saw deleted the
     gift, we read that as "shopper said no thanks" and stopped re-adding;
     and after we removed the gift the drawer kept showing it. Now: the
     gift is added through the drawer's public API
     (window.SectionStoreCart.addItem — it re-renders from the response);
     removals / quantity fixes are done by LINE KEY via /cart/update.js
     (never by line number, so they can't hit the wrong item — the API's
     own removeLine converts key → line number from its cache and threw
     "Cart line could not be found" in a race), followed by
     SectionStoreCart.refresh() so the drawer re-reads the cart. "No thanks"
     is only recorded when the drawer itself reports the shopper removing
     the gift line (section-store:cart:item-removed, outside our own
     operations); a gift that vanishes any other way is simply re-added.
     Also re-checks right after any drawer change
     (section-store:cart:updated) instead of waiting for the 4s poll. */
(function () {
  var GIFT_VARIANT = 47844868063403;
  var THRESHOLD = 8000; // $80 in cents — keep in sync with Block 8's GIFT_AT
  var busy = false;
  var failures = 0;
  var giftTitle = null;
  var mem = {};
  var ownOpUntil = 0;       // v6: cart events before this time are caused by us
  var shopperRemovedAt = 0; // v6: when the drawer last reported the shopper removing the gift
  function sget(k) { try { var v = sessionStorage.getItem(k); if (v !== null) return v; } catch (e) {} return mem[k] || null; }
  function sset(k, v) { mem[k] = v; try { sessionStorage.setItem(k, v); } catch (e) {} }
  function sdel(k) { delete mem[k]; try { sessionStorage.removeItem(k); } catch (e) {} }
  function ssApi() {
    var a = window.SectionStoreCart;
    return (a && typeof a.addItem === 'function' && typeof a.refresh === 'function') ? a : null;
  }
  function whenReady(api) {
    var r = api.ready && typeof api.ready.then === 'function' ? api.ready : Promise.resolve();
    return Promise.race([r, new Promise(function (res) { setTimeout(res, 3000); })]);
  }
  function resync() { // make the drawer re-read the cart so its line numbers match
    var api = ssApi();
    if (!api) return;
    try { var p = api.refresh(); if (p && typeof p.catch === 'function') p.catch(function () {}); } catch (e) {}
  }
  function giftLines(cart) {
    return cart.items.filter(function (it) { return it.variant_id === GIFT_VARIANT; });
  }
  function eligibleTotal(cart) {
    var sum = 0;
    cart.items.forEach(function (it) {
      if (it.variant_id === GIFT_VARIANT) return;
      if ((it.product_type || '').toLowerCase() === 'add-on') return;
      if (/wholesale/i.test(it.product_title || it.title || '')) return;
      sum += it.final_line_price;
    });
    return sum;
  }
  function begin() { busy = true; ownOpUntil = Date.now() + 15000; }
  function finish(ok, done) { busy = false; ownOpUntil = Date.now() + 2500; if (done) done(ok); }
  var GIFT_ITEM = { id: GIFT_VARIANT, quantity: 1, properties: { _t4e_free_gift: '1' } };
  function addGift(done) {
    begin();
    var api = ssApi();
    var viaApi = api ? whenReady(api).then(function () { return api.addItem(GIFT_ITEM); }) : Promise.reject();
    viaApi.then(function () { finish(true, done); }, function () {
      // no drawer API (or it failed) → plain add, then have the drawer re-read the cart
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(GIFT_ITEM) })
        .then(function (r) { resync(); finish(!!(r && r.ok), done); })
        .catch(function () { finish(false, done); });
    });
  }
  function setLines(ups, done) { // ups = { lineKey: quantity } — by key, never by line number
    begin();
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: ups }) })
      .then(function (r) { resync(); finish(!!(r && r.ok), done); })
      .catch(function () { finish(false, done); });
  }
  // The drawer tells us when a line is removed through its own UI
  window.addEventListener('section-store:cart:item-removed', function (e) {
    if (Date.now() < ownOpUntil) return;
    var lines = (e.detail && e.detail.lines) || [];
    for (var i = 0; i < lines.length; i++) {
      if (lines[i] && lines[i].variant_id === GIFT_VARIANT) { shopperRemovedAt = Date.now(); break; }
    }
  });
  function check() {
    if (busy) return;
    if (window.__t4eGiftHold && Date.now() - window.__t4eGiftHold < 20000) return;
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (busy) return;
      var lines = giftLines(cart);
      var total = eligibleTotal(cart);
      if (lines.length) giftTitle = lines[0].product_title || giftTitle;
      if (lines.length && total < THRESHOLD) {
        var offs = {};
        lines.forEach(function (l) { offs[l.key] = 0; });
        setLines(offs, function () { sdel('t4e-gift-added'); });
        return;
      }
      if (lines.length) {
        var keep = null;
        for (var i = 0; i < lines.length; i++) { if (lines[i].properties && lines[i].properties._t4e_free_gift) { keep = lines[i]; break; } }
        if (!keep) keep = lines[0];
        var ups = {}, need = false;
        lines.forEach(function (l) {
          var q = (l === keep) ? 1 : 0;
          if (l.quantity !== q) { ups[l.key] = q; need = true; }
        });
        if (need) setLines(ups);
        sset('t4e-gift-added', '1');
        return;
      }
      if (sget('t4e-gift-added') && total >= THRESHOLD) {
        // the gift we added is gone while the cart is still eligible: only the
        // shopper deleting it in the drawer (reported in the last 30s) means "no thanks"
        if (Date.now() - shopperRemovedAt < 30000) sset('t4e-gift-dismissed', '1');
        sdel('t4e-gift-added');
      }
      if (total >= THRESHOLD && !sget('t4e-gift-dismissed') && failures < 3) {
        addGift(function (ok) { if (ok) { sset('t4e-gift-added', '1'); } else { failures++; } });
      }
    }).catch(function () {});
  }
  // Hide the quantity stepper on the gift line inside the Section Store drawer
  function hideGiftStepper() {
    var ss = document.querySelector('section-store--cart-block');
    var root = ss && ss.shadowRoot;
    if (!root) return;
    var titleRe = giftTitle ? new RegExp(giftTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : /free gift/i;
    root.querySelectorAll('.cart-line-item').forEach(function (line) {
      if (!titleRe.test(line.textContent || '')) return;
      var q = line.querySelector('.cart-line-quantity');
      if (q && q.style.display !== 'none') q.style.display = 'none';
    });
  }
  var observed = false;
  function watchDrawer() {
    var ss = document.querySelector('section-store--cart-block');
    var root = ss && ss.shadowRoot;
    if (!root || observed) return;
    observed = true;
    new MutationObserver(function () { setTimeout(hideGiftStepper, 50); }).observe(root, { childList: true, subtree: true });
    hideGiftStepper();
  }
  var quick;
  window.addEventListener('section-store:cart:updated', function () { clearTimeout(quick); quick = setTimeout(check, 400); });
  setInterval(function () { check(); watchDrawer(); hideGiftStepper(); }, 4000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(function () { check(); watchDrawer(); }, 2500); });
  } else {
    setTimeout(function () { check(); watchDrawer(); }, 2500);
  }
})();

/* ---- Block 14: pre-order notice in the cart drawer (6 Oct 2026) ----
   When any cart line is a pre-order (carries the "Pre-order" line property
   from Block 9, or its title matches /beeswax/i as a fallback), a notice is
   inserted under the reward bar in the Section Store drawer: the whole order
   ships on the pre-order date — place a separate order for anything wanted
   sooner. Shown only when needed. Date is duplicated here — keep in sync
   with snippets/t4e-site-overrides.liquid. Remove with Block 9. */
(function () {
  var SHIP = 'Wednesday 4 November';
  var RE = /beeswax/i;
  var t, busy = false;
  function host() { var ss = document.querySelector('section-store--cart-block'); return ss && ss.shadowRoot ? ss.shadowRoot : null; }
  function isPre(it) { return !!((it.properties && it.properties['Pre-order']) || RE.test(it.product_title || '')); }
  function refresh() {
    var root = host();
    if (!root || busy) return;
    busy = true;
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      busy = false;
      var root2 = host();
      if (!root2) return;
      var body = root2.querySelector('.cart-body');
      if (!body) return;
      var has = (cart.items || []).some(isPre);
      var el = root2.getElementById('t4e-preorder-note');
      if (!has) { if (el) el.parentNode.removeChild(el); return; }
      if (el && el.parentNode === body) return;
      if (el) el.parentNode.removeChild(el);
      el = document.createElement('div');
      el.id = 't4e-preorder-note';
      el.style.cssText = 'margin:0 16px 12px;padding:10px 12px;border:1px solid #f3c9a8;background:#fff7f0;border-radius:8px;font-size:13px;line-height:1.45;color:#1f2a44;';
      el.innerHTML = '<strong>Pre-order in your cart.</strong> Your whole order ships on <strong>' + SHIP + '</strong>. Want the other items sooner? Place them as a separate order.';
      var bar = root2.getElementById('t4e-drawer-ship-bar');
      if (bar && bar.parentNode === body) body.insertBefore(el, bar.nextSibling); else body.insertBefore(el, body.firstChild);
    }).catch(function () { busy = false; });
  }
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 400); }
  var observed = false;
  function watch() {
    var root = host();
    if (!root || observed) return;
    observed = true;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n && n.id === 't4e-preorder-note') continue;
        schedule(); return;
      }
    }).observe(root, { childList: true, subtree: true });
  }
  window.addEventListener('section-store:cart:updated', schedule);
  window.addEventListener('section-store:cart:opened', schedule);
  setInterval(function () { watch(); if (host()) refresh(); }, 5000);
  setTimeout(function () { watch(); refresh(); }, 2000);
})();

/* ---- Block 11: checkout upsell popup (v11 — rule builder + frequency + timer) ----
   When the shopper clicks Checkout (Section Store drawer or /cart page),
   show ONE rule's offers (1–3 products) then continue to checkout. Rules
   come from Customize -> Popups -> "T4E — Checkout upsell"
   (sections/t4e-checkout-upsell.liquid renders window.T4E_UPSELL):
     each rule = trigger (any / products from collections / specific
     products, pre-expanded to product handles) + exclusions (don't show
     if the cart already has…) + headline/blurb + up to 3 offers, each
     with its own product, discount code and % shown.
   Rules are checked top to bottom; first match with something left to
   offer wins. Products already in the cart are never offered. Shoppers
   tick the ones they want; codes for the chosen items are applied via
   /cart/update.js (comma-joined with any code already on the cart). If a
   code won't apply (non-combinable code present) that item is removed
   again and the shopper told. If the additions tip the cart over $80 the
   free gift is added here too. No config / no rules = no popup.
   Frequency (section setting "Show the popup"): every = every Checkout
   click; changed = only when the cart differs from the last time it was
   shown (fingerprint in sessionStorage, gift line ignored); once = once
   per browser session.
   Countdown timer (per rule, off by default): "<timer text> mm:ss" under
   the headline; when it reaches 0:00 the popup closes and the shopper
   continues to checkout without the offers (unless an add is already in
   flight). Up to 5 offers per rule. Wholesale lines (product type
   "Wholesale…" or title containing "wholesale") are ignored, so a
   wholesale-only cart gets no popup.
   z-index is the CSS maximum (2147483647): the Section Store drawer sits at
   2147483001, which hid the popup completely on phones (v6 and earlier).
   Non-combinable discounts: if the cart already carries a discount that is
   not in the section's "combinable" allow-list (Fast Bundle's automatic
   BUNDLE discount, Loox codes…), our product codes would be refused by
   Shopify, so the offers are shown at FULL price — headline + cards only,
   the rule text is hidden because it mentions the discount; an optional
   note from the section setting can replace it (blank by default) — or the
   popup is skipped, per the section setting. This instead of promising 10%
   and then removing the item at accept time (what happened on 20 Sep).
   Gift: on accept, window.__t4eGiftHold pauses Block 10, the gift is added
   here if the cart crossed $80, then every gift line is collapsed to ONE at
   quantity 1 before the redirect (order #3164 shipped with 2 gifts because
   Block 10 and this block added it simultaneously).
   Config size: the section renders each referenced collection's product
   handles ONCE (CFG.collections) and rules reference them by handle (tc/xc)
   plus specific products (tp/xp); the old pre-expanded triggerHandles /
   excludeHandles shape is still accepted. Cut the per-page inline config
   from ~22 KB to ~5 KB. */
(function () {
  var CFG = window.T4E_UPSELL || {};
  if (CFG.enabled === false || !CFG.rules) return;
  var GIFT_VARIANT = 47844868063403, GIFT_AT = 8000; // keep in sync with Block 10
  var RULES = [];
  var COLS = CFG.collections || {}; // handle -> [product handles], rendered once per collection (v11+)
  function expand(cols, prods) {
    var out = [];
    (cols || []).forEach(function (h) { (COLS[h] || []).forEach(function (p) { if (p) out.push(p); }); });
    (prods || []).forEach(function (p) { if (p) out.push(p); });
    return out;
  }
  (CFG.rules || []).forEach(function (r) {
    if (!r || r.enabled === false) return;
    var offers = (r.offers || []).filter(function (o) { return o && o.handle; }).map(function (o) {
      return { handle: o.handle, code: String(o.code || '').trim(), pct: Number(o.pct) || 0 };
    });
    if (!offers.length) return;
    RULES.push({
      trigger: r.trigger || 'collections',
      triggerHandles: r.triggerHandles ? r.triggerHandles.filter(Boolean) : expand(r.tc, r.tp),
      excludeHandles: r.excludeHandles ? r.excludeHandles.filter(Boolean) : expand(r.xc, r.xp),
      headline: r.headline || 'One more thing',
      blurb: r.blurb || '',
      timer: r.timer === true ? Math.max(1, Math.min(60, Number(r.timerMinutes) || 5)) : 0, // minutes, 0 = off
      offers: offers
    });
  });
  if (!RULES.length) return;
  var EYEBROW = CFG.eyebrow || 'One more thing';
  var BTN_YES = CFG.btnYes || 'Continue to checkout';
  var BTN_NO = CFG.btnNo || 'No thanks, continue to checkout';
  var TIMER_TEXT = CFG.timerText || 'Limited time offer! Expires in';
  var ALLOW = String(CFG.allowDiscounts || 'T4E-, KEEPBREADFRESH, Discount for 2, Discount for 3, AOVAI').split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
  var BLOCKED_MODE = CFG.blockedMode === 'skip' ? 'skip' : 'full';
  var BLOCKED_NOTE = String(CFG.blockedNote || '').trim();
  function discountNames(cart) {
    var names = {};
    (cart.discount_codes || []).forEach(function (d) { if (d && d.applicable && d.code) names[String(d.code)] = 1; });
    function app(a) { var t = a && a.discount_application && a.discount_application.title; if (t) names[String(t)] = 1; }
    (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(app); });
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (d && d.title) names[String(d.title)] = 1; });
    return Object.keys(names);
  }
  function isBlocked(cart) {
    return discountNames(cart).some(function (n) {
      var u = n.trim().toUpperCase();
      return !ALLOW.some(function (a) { return u === a || u.indexOf(a) === 0; });
    });
  }
  var FREQ = CFG.frequency || (CFG.once === false ? 'every' : 'once'); // every | changed | once
  var mem = {};
  function sget(k) { try { var v = sessionStorage.getItem(k); if (v !== null) return v; } catch (e) {} return mem[k] || null; }
  function sset(k, v) { mem[k] = v; try { sessionStorage.setItem(k, v); } catch (e) {} }
  var open = false;
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function fingerprint(cart) {
    return (cart.items || []).filter(function (it) { return it.variant_id !== GIFT_VARIANT; })
      .map(function (it) { return it.variant_id + 'x' + it.quantity; }).sort().join(',');
  }
  function pick(cart) {
    var have = {};
    var real = 0;
    cart.items.forEach(function (it) {
      if (/^wholesale/i.test(it.product_type || '') || /wholesale/i.test(it.product_title || '')) return;
      if (it.handle) have[it.handle] = true;
      if (it.variant_id !== GIFT_VARIANT) real++;
    });
    if (!real) return null;
    for (var i = 0; i < RULES.length; i++) {
      var r = RULES[i];
      var hit = r.trigger === 'any' || r.triggerHandles.some(function (h) { return have[h]; });
      if (!hit) continue;
      if (r.excludeHandles.some(function (h) { return have[h]; })) continue;
      var offers = r.offers.filter(function (o) { return !have[o.handle]; });
      if (!offers.length) continue;
      return { rule: r, offers: offers };
    }
    return null;
  }
  function ensureGift(cart) {
    var sum = 0, has = false;
    cart.items.forEach(function (it) {
      if (it.variant_id === GIFT_VARIANT) { has = true; return; }
      if ((it.product_type || '').toLowerCase() === 'add-on') return;
      if (/wholesale/i.test(it.product_title || '')) return;
      sum += it.final_line_price;
    });
    var add = (has || sum < GIFT_AT) ? Promise.resolve() : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: GIFT_VARIANT, quantity: 1, properties: { _t4e_free_gift: '1' } }) }).catch(function () {});
    // whatever happened, leave exactly one gift line at quantity 1 (or none if under $80)
    return add.then(function () { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); }).then(function (c) {
      var lines = c.items.filter(function (it) { return it.variant_id === GIFT_VARIANT; });
      if (!lines.length) return;
      var eligible = sum >= GIFT_AT;
      var keep = null;
      for (var i = 0; i < lines.length; i++) { if (lines[i].properties && lines[i].properties._t4e_free_gift) { keep = lines[i]; break; } }
      if (!keep) keep = lines[0];
      var ups = {}, need = false;
      lines.forEach(function (l) { var q = (eligible && l === keep) ? 1 : 0; if (l.quantity !== q) { ups[l.key] = q; need = true; } });
      if (!need) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: ups }) }).catch(function () {});
    }).catch(function () {});
  }
  function goCheckout() { window.location.href = '/checkout'; }
  function isCheckoutClick(e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.tagName) continue;
      var tag = el.tagName;
      if (tag !== 'BUTTON' && tag !== 'A' && tag !== 'INPUT') continue;
      if (el.getAttribute && el.getAttribute('name') === 'checkout') return true;
      if (/^\s*checkout\b/i.test((el.textContent || el.value || '').trim())) return true;
      if (el.getAttribute && /\/checkout/.test(el.getAttribute('href') || '')) return true;
    }
    return false;
  }
  document.addEventListener('click', function (e) {
    if (open) return;
    if (FREQ === 'once' && sget('t4e-upsell-shown')) return;
    if (!isCheckoutClick(e)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open = true;
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var fp = fingerprint(cart);
      if (FREQ === 'changed' && fp && sget('t4e-upsell-fp') === fp) { open = false; goCheckout(); return; }
      var m = cart.item_count ? pick(cart) : null;
      if (!m) { open = false; goCheckout(); return; }
      var blocked = isBlocked(cart);
      if (blocked && BLOCKED_MODE === 'skip') { open = false; goCheckout(); return; }
      return Promise.all(m.offers.map(function (o) {
        if (blocked) o = { handle: o.handle, code: '', pct: 0 };
        return fetch('/products/' + o.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p || !p.available) return null;
          var variants = (p.variants || []).filter(function (v) { return v.available; });
          if (!variants.length) return null;
          return { offer: o, product: p, variants: variants, sel: variants[0], chosen: false };
        }).catch(function () { return null; });
      })).then(function (items) {
        items = items.filter(Boolean);
        if (!items.length) { open = false; goCheckout(); return; }
        sset('t4e-upsell-shown', '1');
        sset('t4e-upsell-fp', fp);
        show(m.rule, items, blocked);
      });
    }).catch(function () { open = false; goCheckout(); });
  }, true);
  function show(rule, items, blocked) {
    var wrap = document.createElement('div');
    wrap.id = 't4e-upsell';
    wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(32,47,66,.55);display:flex;align-items:center;justify-content:center;padding:16px;';
    var card = document.createElement('div');
    card.style.cssText = 'background:#fff;border-radius:14px;max-width:440px;width:100%;max-height:92vh;overflow:auto;padding:22px 22px 18px;box-shadow:0 20px 60px rgba(0,0,0,.35);font-family:inherit;color:#202F42;position:relative;';
    function priceHtml(it) {
      var disc = it.offer.code && it.offer.pct > 0;
      if (!disc) return '<b style="font-size:17px;color:#202F42;">' + money(it.sel.price) + '</b>';
      var d = Math.round(it.sel.price * (100 - it.offer.pct) / 100);
      return '<span style="text-decoration:line-through;color:#8a94a3;margin-right:6px;font-size:13px;">' + money(it.sel.price) + '</span><b style="font-size:17px;color:#F27B26;">' + money(d) + '</b><span style="font-size:11px;color:#F27B26;margin-left:6px;font-weight:700;">SAVE ' + it.offer.pct + '%</span>';
    }
    var rows = items.map(function (it, i) {
      var img = it.product.featured_image || (it.product.images && it.product.images[0]) || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var vsel = '';
      if (it.variants.length > 1) {
        vsel = '<select data-vsel="' + i + '" style="margin-top:6px;font-size:12px;padding:4px 6px;border:1px solid #d9dde3;border-radius:6px;max-width:100%;">' + it.variants.map(function (v) { return '<option value="' + v.id + '">' + v.title + '</option>'; }).join('') + '</select>';
      }
      return '<div data-row="' + i + '" style="display:flex;gap:12px;align-items:center;padding:10px;border:1.5px solid #e6e9ee;border-radius:10px;margin-top:8px;">' +
        (img ? '<img src="' + img + '" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:8px;flex:none;">' : '') +
        '<div style="flex:1;min-width:0;"><div style="font-weight:600;font-size:14px;line-height:1.25;">' + it.product.title + '</div><div data-price="' + i + '" style="margin-top:3px;">' + priceHtml(it) + '</div>' + vsel + '</div>' +
        '<button type="button" data-add="' + i + '" style="flex:none;padding:8px 12px;border-radius:6px;border:1.5px solid #F27B26;background:#fff;color:#F27B26;font-size:13px;font-weight:700;cursor:pointer;min-width:74px;">+ Add</button>' +
      '</div>';
    }).join('');
    card.innerHTML =
      '<button type="button" data-x aria-label="Close" style="position:absolute;top:10px;right:12px;border:0;background:none;font-size:24px;line-height:1;color:#8a94a3;cursor:pointer;">×</button>' +
      '<div style="font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#F27B26;font-weight:700;margin-bottom:6px;">' + EYEBROW + '</div>' +
      '<div style="font-size:21px;font-weight:700;line-height:1.2;margin-bottom:6px;">' + rule.headline + '</div>' +
      (rule.timer ? '<div data-timer style="font-size:14px;color:#3b4656;margin-bottom:8px;">' + TIMER_TEXT + ' <b data-clock style="font-variant-numeric:tabular-nums;color:#202F42;font-size:16px;margin-left:4px;"></b></div>' : '') +
      (blocked ? (BLOCKED_NOTE ? '<p style="font-size:13px;line-height:1.45;margin:0 0 6px;color:#3b4656;">' + BLOCKED_NOTE + '</p>' : '') : (rule.blurb ? '<p style="font-size:14px;line-height:1.45;margin:0 0 6px;color:#3b4656;">' + rule.blurb + '</p>' : '')) +
      rows +
      '<div data-msg style="display:none;font-size:13px;color:#b42318;margin:8px 0 0;"></div>' +
      '<button type="button" data-yes style="display:block;width:100%;margin-top:14px;padding:14px;border:0;border-radius:8px;background:#F27B26;color:#fff;font-size:15px;font-weight:700;cursor:pointer;">' + BTN_YES + '</button>' +
      '<button type="button" data-no style="display:block;width:100%;margin-top:8px;padding:10px;border:0;background:none;color:#5b6675;font-size:13px;text-decoration:underline;cursor:pointer;">' + BTN_NO + '</button>';
    wrap.appendChild(card);
    document.body.appendChild(wrap);
    var busy = false, tick = null;
    function close() { if (tick) { clearInterval(tick); tick = null; } if (wrap.parentNode) wrap.parentNode.removeChild(wrap); open = false; }
    var yes = card.querySelector('[data-yes]');
    if (rule.timer) {
      var clock = card.querySelector('[data-clock]');
      var endAt = Date.now() + rule.timer * 60000;
      var paint = function () {
        var left = Math.max(0, Math.round((endAt - Date.now()) / 1000));
        var mm = Math.floor(left / 60), ss = left % 60;
        clock.textContent = (mm < 10 ? '0' : '') + mm + ' : ' + (ss < 10 ? '0' : '') + ss;
        if (left <= 0) { clearInterval(tick); tick = null; if (!busy) { close(); goCheckout(); } }
      };
      paint();
      tick = setInterval(paint, 500);
    }
    function refreshYes() {
      var n = items.filter(function (it) { return it.chosen; }).length;
      yes.textContent = n ? ('Add ' + n + ' item' + (n > 1 ? 's' : '') + ' & checkout') : BTN_YES;
    }
    card.querySelector('[data-x]').addEventListener('click', close);
    card.querySelector('[data-no]').addEventListener('click', function () { close(); goCheckout(); });
    wrap.addEventListener('click', function (ev) { if (ev.target === wrap) close(); });
    Array.prototype.forEach.call(card.querySelectorAll('[data-add]'), function (b) {
      b.addEventListener('click', function () {
        if (busy) return;
        var it = items[parseInt(b.getAttribute('data-add'), 10)];
        it.chosen = !it.chosen;
        b.textContent = it.chosen ? '✓ Added' : '+ Add';
        b.style.background = it.chosen ? '#F27B26' : '#fff';
        b.style.color = it.chosen ? '#fff' : '#F27B26';
        var row = card.querySelector('[data-row="' + b.getAttribute('data-add') + '"]');
        if (row) row.style.borderColor = it.chosen ? '#F27B26' : '#e6e9ee';
        refreshYes();
      });
    });
    Array.prototype.forEach.call(card.querySelectorAll('[data-vsel]'), function (s) {
      s.addEventListener('change', function () {
        var idx = parseInt(s.getAttribute('data-vsel'), 10), it = items[idx];
        var id = parseInt(s.value, 10);
        it.variants.forEach(function (v) { if (v.id === id) it.sel = v; });
        card.querySelector('[data-price="' + idx + '"]').innerHTML = priceHtml(it);
      });
    });
    yes.addEventListener('click', function () {
      var chosen = items.filter(function (it) { return it.chosen; });
      if (!chosen.length) { close(); goCheckout(); return; }
      busy = true;
      window.__t4eGiftHold = Date.now();
      yes.disabled = true; yes.textContent = 'Adding…';
      var added = [];
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: chosen.map(function (it) { return { id: it.sel.id, quantity: 1, properties: { _t4e_checkout_offer: '1' } }; }) }) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          added = (res && res.items) || [];
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var want = chosen.map(function (it) { return it.offer.code; }).filter(Boolean);
          if (!want.length) return cart;
          var keep = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          var all = keep.concat(want.filter(function (c) { return keep.indexOf(c) === -1; }));
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: all.join(',') }) })
            .then(function () { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); });
        })
        .then(function (cart) {
          var applied = {};
          (cart.discount_codes || []).forEach(function (d) { if (d.applicable) applied[d.code] = true; });
          var failed = chosen.filter(function (it) { return it.offer.code && !applied[it.offer.code]; });
          if (!failed.length) return ensureGift(cart).then(goCheckout);
          // undo the items whose offer code Shopify wouldn't apply, then explain and continue
          var ups = {};
          cart.items.forEach(function (line) {
            failed.forEach(function (it) { if (line.variant_id === it.sel.id && line.properties && line.properties._t4e_checkout_offer) ups[line.key] = 0; });
          });
          var undo = Object.keys(ups).length ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: ups }) }) : Promise.resolve();
          return undo.then(function () {
            var m = card.querySelector('[data-msg]');
            m.textContent = 'Sorry — ' + failed.map(function (it) { return it.product.title; }).join(', ') + ' can’t be discounted alongside the code already on your order, so it wasn’t added. Taking you to checkout…';
            m.style.display = 'block';
            setTimeout(goCheckout, 2600);
          });
        })
        .catch(function () { goCheckout(); });
    });
  }
})();

/* ---- Block 12: Fast Bundle "mix & match" pages — make the disabled Add to cart obvious ----
   On mix & match bundle pages (Fast Bundle renders one accordion section per
   slot: "Bread Board … Add 1 item") the theme's Add to cart button is
   disabled until every section has a pick, but the custom ATC styling paints
   it full orange, so shoppers tap it, nothing happens and they report the
   site as broken (chat from the Ultimate Bread Keeper's Bundle page, 24 Sep
   2026). While it's disabled on these pages: grey it out, relabel it
   "Choose your items above", and turn a tap into help — a hint line under
   the button, plus open + scroll to the first section still waiting for a
   pick. The label is restored the moment Fast Bundle enables the button.
   Detection: any element whose class contains "Accordion_head" (Fast
   Bundle's hashed class names, e.g. Accordion_head_dba7dcc1).
   Since 24 Sep snippets/product-form.liquid renders the waiting state
   server-side for type "Bundle" products (no orange→grey flash); this
   block then only has to restore "Add to cart" and handle the tap. */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  var LABEL = 'Choose your items above';
  var HINT = 'Pick one item from each section above, then add to cart.';
  var btn = null, span = null, orig = '', styled = false, hint = null;
  function heads() { return document.querySelectorAll('[class*="Accordion_head"]'); }
  function isMix() { return heads().length > 0; }
  function findBtn() {
    return document.querySelector('.custom_atc_wrapper button[name="add"]') ||
           document.querySelector('form[action*="/cart/add"] button[name="add"]');
  }
  function apply() {
    if (!btn) btn = findBtn();
    if (!btn || !isMix()) return;
    if (!span) span = btn.querySelector('[data-add-to-cart-text]') || btn;
    if (btn.disabled) {
      if (!styled) { orig = span.textContent; styled = true; btn.classList.add('t4e-atc-wait'); }
      if (/add to cart/i.test(span.textContent)) span.textContent = LABEL;
    } else if (styled) {
      styled = false;
      btn.classList.remove('t4e-atc-wait');
      if (span.textContent.trim() === LABEL) span.textContent = /add to cart/i.test(orig) ? orig : 'Add to cart';
      if (hint) hint.style.display = 'none';
    }
  }
  var css = document.createElement('style');
  css.textContent = '.t4e-atc-wait{pointer-events:none !important;opacity:.55 !important;filter:grayscale(1);}' +
    '.t4e-atc-hint{display:none;margin:8px 0 0;font-size:13px;line-height:1.4;color:#b42318;text-align:center;}';
  document.head.appendChild(css);
  document.addEventListener('click', function (e) {
    if (!btn || !btn.disabled || !isMix()) return;
    var wrap = btn.closest('.atc_main_wrapper') || btn.parentElement;
    if (!wrap || !wrap.contains(e.target)) return;
    e.preventDefault();
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 't4e-atc-hint';
      hint.textContent = HINT;
      wrap.parentNode.insertBefore(hint, wrap.nextSibling);
    }
    hint.style.display = 'block';
    var hs = heads(), target = null;
    for (var i = 0; i < hs.length; i++) { if (/add\s+\d+\s+item/i.test(hs[i].textContent || '')) { target = hs[i]; break; } }
    if (target) {
      var arrow = target.querySelector('[class*="Accordion_arrow"]');
      var isOpen = arrow && /arrow_active/i.test(arrow.getAttribute('class') || '');
      if (!isOpen) target.click();
      setTimeout(function () { try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { target.scrollIntoView(); } }, 150);
    }
  }, true);
  var t;
  function run() { clearTimeout(t); t = setTimeout(apply, 100); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
})();
/* ---- Block 13: sticky Add to cart bar on mobile product pages (v2, 26 Sep 2026) ----
   v2: the bar's first line now says WHAT will be added — on the bread-bag
   Qty table it reads e.g. "2 Pack: White, Pink" and follows every pack /
   colour change; on other products it adds the chosen variant ("· Right
   Hand"). Two lines allowed before clamping. Also lifts Klaviyo's corner
   "Get 10% off" teaser (and re-applies the Inbox lift every second, so a
   late-loading chat pill still moves) instead of letting them cover the bar.
   Mobile only (max-width 768px). A slim bar pinned to the bottom of the screen
   shows the product name, the current price and an Add to cart button whenever
   the page's REAL add-to-cart button is off-screen (bundle/upsell modules push
   it ~1,100px down on phones). Tapping the bar presses the real button, so the
   chosen pack / colour / variant / Fast Bundle picks all still apply. If the
   real button is disabled (Fast Bundle waiting for picks, sold out) the bar
   scrolls to it instead. Hidden while any drawer or popup is open. Also lifts
   Shopify Inbox's "Ask anything" pill above the bar so they never overlap.
   Targets, in order: .bundle-atc-btn (bread-bag Qty table), then the product
   form's button[name="add"] (outside quick-shop modals). */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var MQ = window.matchMedia('(max-width: 768px)');
  var BAR_H = 66;
  var bar, titleEl, priceEl, btnEl, target = null, io = null, targetVisible = true, shown = false;

  function isModal(el) { return !!el.closest('.modal, .quick-product, [id^="QuickShopModal"], [data-product-blocks-modal], .drawer'); }
  function findTarget() {
    var sels = ['.bundle-atc-btn', 'form[action*="/cart/add"] button[name="add"]'];
    for (var i = 0; i < sels.length; i++) {
      var list = document.querySelectorAll(sels[i]);
      for (var j = 0; j < list.length; j++) {
        var b = list[j];
        if (isModal(b)) continue;
        if (b.getClientRects().length) return b;
      }
    }
    return null;
  }
  function isDisabled(b) { return !!(b.disabled || b.getAttribute('aria-disabled') === 'true' || b.classList.contains('t4e-atc-wait')); }
  function label(b) {
    var txt = (b.textContent || '').replace(/\s+/g, ' ').trim();
    if (/sold out/i.test(txt)) return 'Sold out';
    if (/pre-?order/i.test(txt)) return 'Pre-order';
    if (b.classList.contains('t4e-atc-wait') || /choose/i.test(txt)) return 'Choose items';
    return 'Add to cart';
  }
  function priceText() {
    var el = document.querySelector('.bundle-option.active .bundle-price') ||
             document.querySelector('.product-single__meta .product__price:not(.product__price--compare)') ||
             document.querySelector('[data-product-price]');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function build() {
    if (bar) return;
    var st = document.createElement('style');
    st.textContent =
      '#t4e-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:900;display:flex;align-items:center;gap:12px;' +
      'padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -4px 16px rgba(0,0,0,.12);' +
      'transform:translateY(110%);transition:transform .25s ease;}' +
      '#t4e-sticky-atc.on{transform:translateY(0);}' +
      '#t4e-sticky-atc .t4e-sa-info{flex:1;min-width:0;}' +
      '#t4e-sticky-atc .t4e-sa-title{font-size:13px;line-height:1.25;color:#1f2a44;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}' +
      '#t4e-sticky-atc .t4e-sa-price{font-size:16px;font-weight:700;color:#1f2a44;margin-top:2px;}' +
      '#t4e-sticky-atc .t4e-sa-btn{flex:0 0 auto;min-width:140px;height:46px;padding:0 18px;border:0;border-radius:8px;background:#F27B26;color:#fff;' +
      'font-size:15px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;}' +
      '#t4e-sticky-atc .t4e-sa-btn.is-wait{background:#9aa0a6;}' +
      'body.t4e-sticky-on{padding-bottom:' + BAR_H + 'px;}';
    document.head.appendChild(st);
    bar = document.createElement('div');
    bar.id = 't4e-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="t4e-sa-info"><div class="t4e-sa-title"></div><div class="t4e-sa-price"></div></div>' +
                    '<button type="button" class="t4e-sa-btn">Add to cart</button>';
    titleEl = bar.querySelector('.t4e-sa-title');
    priceEl = bar.querySelector('.t4e-sa-price');
    btnEl = bar.querySelector('.t4e-sa-btn');
    btnEl.addEventListener('click', function () {
      if (!target) return;
      if (isDisabled(target)) {
        try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { target.scrollIntoView(); }
        return;
      }
      target.click();
    });
    document.body.appendChild(bar);
  }
  function overlayOpen() {
    var h = document.documentElement, b = document.body;
    if (h.classList.contains('js-drawer-open') || b.classList.contains('js-drawer-open') || h.classList.contains('modal-open') || b.classList.contains('modal-open')) return true;
    var up = document.querySelector('.t4e-upsell-overlay, #t4e-upsell');
    return !!(up && up.getClientRects().length);
  }
  function productName() {
    var h1 = document.querySelector('.product-single__meta h1, h1');
    return h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function titleText() {
    // Bread-bag Qty table: "2 Pack: White, Pink" (follows the pack + colour picks)
    var act = document.querySelector('.bundle-option.active');
    if (act) {
      var pl = act.querySelector('.bundle-pack-label');
      var pack = pl ? pl.textContent.replace(/\s+/g, ' ').trim().toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); }) : '';
      var ct = act.querySelector('[class^="selected-colors-text"], [class*=" selected-colors-text"]');
      var cols = ct ? ct.textContent.replace(/\s+/g, ' ').trim() : '';
      if (pack && cols) return pack + ': ' + cols;
      if (pack) return pack + ' · ' + productName();
    }
    // Everything else: product name + chosen variant ("· Right Hand")
    var name = productName();
    var sel = target && target.form ? target.form.querySelector('select[name="id"]') : null;
    if (sel && sel.selectedIndex >= 0) {
      var v = (sel.options[sel.selectedIndex].text || '').split(' - ')[0].replace(/\s+/g, ' ').trim();
      if (v && !/^default title$/i.test(v) && name.toLowerCase().indexOf(v.toLowerCase()) === -1) return name + ' · ' + v;
    }
    return name;
  }
  function lifted(el, on) {
    el.style.transition = 'transform .25s ease';
    el.style.transform = on ? 'translateY(-' + BAR_H + 'px)' : '';
  }
  function liftChat(on) {
    var c = document.querySelector('shopify-chat');
    var a = c && c.shadowRoot && c.shadowRoot.querySelector('.activator');
    if (a) lifted(a, on);
    // Klaviyo corner teaser ("Get 10% off"): move the element that is itself position:fixed
    var roots = document.querySelectorAll('[class*="kl-teaser"], .needsclick[class*="kl-private"]');
    for (var i = 0; i < roots.length; i++) {
      var list = [roots[i]].concat([].slice.call(roots[i].querySelectorAll('*')));
      for (var j = 0; j < list.length; j++) {
        var el = list[j];
        if (el.id === 't4e-sticky-atc' || el.closest('#t4e-sticky-atc')) continue;
        if (getComputedStyle(el).position !== 'fixed') continue;
        var r = el.getBoundingClientRect();
        if (r.height && r.height < 260 && r.bottom > window.innerHeight - BAR_H - 4) lifted(el, on);
        else if (!on && el.style.transform) lifted(el, false);
        break;
      }
    }
  }
  function update() {
    var want = MQ.matches && target && !targetVisible && !overlayOpen();
    if (!bar && !want) return;
    build();
    if (target) {
      var tt = titleText();
      if (titleEl.textContent !== tt) titleEl.textContent = tt;
      var p = priceText();
      if (priceEl.textContent !== p) priceEl.textContent = p;
      var l = label(target);
      if (btnEl.textContent !== l) btnEl.textContent = l;
      btnEl.classList.toggle('is-wait', isDisabled(target));
    }
    if (want !== shown) {
      shown = want;
      bar.classList.toggle('on', want);
      bar.setAttribute('aria-hidden', want ? 'false' : 'true');
      document.body.classList.toggle('t4e-sticky-on', want);
    }
    liftChat(shown);
  }
  function watchTarget() {
    var t = findTarget();
    if (t === target) return;
    if (io) io.disconnect();
    target = t;
    targetVisible = true;
    if (!target) { update(); return; }
    io = new IntersectionObserver(function (entries) {
      targetVisible = entries[0].isIntersecting;
      update();
    });
    io.observe(target);
  }
  function start() {
    watchTarget();
    setInterval(function () { watchTarget(); update(); }, 1000);
    if (MQ.addEventListener) MQ.addEventListener('change', update);
    document.addEventListener('click', function () { setTimeout(update, 60); }, true);
    var mo = new MutationObserver(update);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
